import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  marketingSkeletonPageWrapper: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    padding: '20px 32px',
    height: 'fit-content',
    width: '100%',
    minWidth: '343px',
    maxWidth: '1451px',
    borderRadius: '0px 12px 12px 12px',
    backgroundColor: theme.palette.background.primary,
  },
  propertyLabelSkeletonSection: {
    display: 'flex',
    alignItems: 'center',
    height: '92px',
    width: '100%',
    maxWidth: '1378px',
    backgroundColor: theme.palette.background.gray_50,
    border: `1px solid ${theme.palette.border.secondary}`,
    borderRadius: '12px',
    padding: '24px 32px',
  },
  priceAndSizeSkeletonSection: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '92px',
    height: 'fit-content',
    width: '100%',
    maxWidth: '1378px',
    backgroundColor: theme.palette.background.gray_50,
    border: `1px solid ${theme.palette.border.secondary}`,
    borderRadius: '12px',
    padding: '24px 32px',
    gap: '20px',
  },
  marketingTitleSkeletonSection: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '169px',
    height: 'fit-content',
    width: '100%',
    maxWidth: '1378px',
    backgroundColor: theme.palette.background.gray_50,
    border: `1px solid ${theme.palette.border.secondary}`,
    borderRadius: '12px',
    padding: '24px 32px',
    gap: '20px',
  },
  marketingUSPSkeletonSection: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '412px',
    height: 'fit-content',
    width: '100%',
    maxWidth: '1378px',
    backgroundColor: theme.palette.background.gray_50,
    border: `1px solid ${theme.palette.border.secondary}`,
    borderRadius: '12px',
    padding: '24px 32px',
    gap: '20px',
  },
  marketingDescriptionSkeletonSection: {
    display: 'flex',
    flexDirection: 'column',
    height: 'fit-content',
    width: '100%',
    maxWidth: '1378px',
    backgroundColor: theme.palette.background.gray_50,
    border: `1px solid ${theme.palette.border.secondary}`,
    borderRadius: '12px',
    padding: '24px 32px',
    gap: '20px',
  },
  additionalFieldsSkeletonSection: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '169px',
    height: 'fit-content',
    width: '100%',
    maxWidth: '1378px',
    backgroundColor: theme.palette.background.gray_50,
    border: `1px solid ${theme.palette.border.secondary}`,
    borderRadius: '12px',
    padding: '24px 32px',
    gap: '20px',
  },
  fieldWrapper: {
    width: '100%',
    height: '100%',
    maxHeight: '44px',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '32px',
    margin: '16px 0',
  },
  priceField: {
    display: 'flex',
    height: 'fit-content',
    maxHeight: '114px',
    gap: '32px',
    alignItems: 'start',
  },
  sizeField: {
    display: 'flex',
    gap: '32px',
    height: 'fit-content',
    maxHeight: '114px',
    alignItems: 'start',
  },
  descriptionFieldWrapper: {
    width: '100%',
    height: '100%',
    maxHeight: '180px',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '32px',
    margin: '16px 0',
  },
}));
